/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Cart/CartManager',[
    'jquery',
    'global/all',
    'global/RocAnalytics',
    'plugins/jquery.proxyRequest'
], function ($, Roc, RocAnalytics) {
    'use strict';

    function trackAddToCart(itemData) {
        var itemModel = {
            'id': itemData.productId,
            'name': itemData.itemName,
            'sku': itemData.sku,
            'externalid': itemData.externalId,
            'variant': itemData.sku,
            'price': itemData.price,
            'qty': Math.abs(itemData.addedQuantity)
        };
        RocAnalytics.recordAddProductToCart(itemModel);
    }

    function trackRemoveFromCart(itemData) {
        var itemModel = {
            'id': itemData.productId,
            'name': itemData.productName,
            'sku': itemData.sku,
            'externalid': itemData.externalId,
            'variant': itemData.sku,
            'price': itemData.price,
            'qty': Math.abs(itemData.qty)
        };
        RocAnalytics.recordRemoveProductFromCart(itemModel);
    }

    function trackCartAddOrRemove(itemData, quantity) {
        var itemModel = {
            'id': itemData.productId,
            'name': itemData.productName,
            'sku': itemData.sku,
            'externalid': itemData.externalId,
            'variant': itemData.sku,
            'price': itemData.price,
            'qty': Math.abs(quantity)
        };

        if (quantity > 0) {
            RocAnalytics.recordAddProductToCart(itemModel);
        } else if (quantity < 0) {
            RocAnalytics.recordRemoveProductFromCart(itemModel);
        }
    }

    /**
     * This function gets shopping cart summary (subtotal, total items count)
     * @returns {} 
     */
    function getSummary() {
        $.ajax({
            type: 'GET',
            url: '/ajax/CartSummary',
            contentType: 'application/json; charset=utf-8',
            complete: function (xhr) {
                Roc.Logger.info('CartManager -> getSummary');
                Roc.Logger.info(xhr);
                Roc.EventManager.notify(Roc.Events.cart.GET_SUMMARY, xhr);
            }
        });
    }

    /**
     * This function adds particular product in reuqested quantity to the shopping cart
     * @param {} productId - ID of product to add
     * @param {} quantity
     * @param {} groupId - ID of group product from which context this item is being added (i.e. group product landing page)
     * @param {} orderItemId
     * @param {} deliveryOptions - delivery options for item
     * @param {} giftCartData - parameters related to gift card form (GiftCard product type).
     * @param {} requestCustomFields - dictiornary of <string, object> for passing custom fields to API
     * @returns {} 
     */
    function addCartItem(productId, quantity, groupId, orderItemId, deliveryOptions, giftCartData, requestCustomFields) {
        if (!quantity) {
            quantity = 1;
        }

        var addToCartRequest = {
            'productId': productId,
            'quantity': quantity,
            'orderId': '{orderId}',
            'RemoteIP': '{RemoteIP}',
            'giftCartData': giftCartData
        }

        if (groupId) {
            addToCartRequest.groupId = groupId;
        }

        if (orderItemId) {
            addToCartRequest.orderItemId = orderItemId;
        }

        if (deliveryOptions) {
            addToCartRequest.deliveryOptions = deliveryOptions;
        }

        addToCartRequest.requestCustomFields = initCartSource(requestCustomFields, Roc.Enums.cartSource.ADD_TO_CART);

        $.proxyRequest({
            type: 'POST',
            url: '/api/store/cart/item/',
            data: JSON.stringify(addToCartRequest),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            serverCompleteAction: 'SetCurrentOrderId',
            complete: function (xhr) {
                Roc.Logger.info('CartManager -> addCartItem');
                Roc.Logger.info(xhr);
                var response = xhr.responseJSON || {};

                // Track Cart Addition to analytics
                trackAddToCart(response);
                Roc.EventManager.notify(Roc.Events.cart.ADD_ITEM, response);
            }
        });
    }


    function addCartItemBySku(productSku, quantity, groupId, orderItemId, deliveryOptions, giftCartData, requestCustomFields) {
        if (!quantity) {
            quantity = 1;
        }
         

        var addToCartRequestBySku = {
            'productSku': productSku,
            'quantity': quantity,
            'orderId': '{orderId}',
            'RemoteIP': '{RemoteIP}',
            'giftCartData': giftCartData
        }

        if (groupId) {
            addToCartRequestBySku.groupId = groupId;
        }

        if (orderItemId) {
            addToCartRequestBySku.orderItemId = orderItemId;
        }

        if (deliveryOptions) {
            addToCartRequestBySku.deliveryOptions = deliveryOptions;
        }

        addToCartRequestBySku.requestCustomFields = initCartSource(requestCustomFields, Roc.Enums.cartSource.ADD_TO_CART);

        $.proxyRequest({
            type: 'POST',
            url: '/api/store/cart/itemBySku/',
            data: JSON.stringify(addToCartRequestBySku),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            serverCompleteAction: 'SetCurrentOrderId',
            complete: function (xhr) {
                Roc.Logger.info('CartManager -> addCartItem');
                Roc.Logger.info(xhr);
                var response = xhr.responseJSON || {};

                // Track Cart Addition to analytics
                trackAddToCart(response);
                Roc.EventManager.notify(Roc.Events.cart.ADD_ITEM, response);
            }
        });
    }

    /**
     * Requests api to update shopping cart item
     * @param {} updateCartItemRequest
     * @param {} requestCustomFields - dictiornary of <string, object> for passing custom fields to API
     * @returns {} 
     */
    function updateCartItem(updateCartItemRequest, requestCustomFields) {
        updateCartItemRequest
            .requestCustomFields = initCartSource(requestCustomFields, Roc.Enums.cartSource.UPDATE_ITEM_QUANTITY);

        $.proxyRequest({
            type: 'POST',
            url: '/api/store/cart/updatequantity/',
            data: JSON.stringify(updateCartItemRequest),
            dataType: 'json',
            complete: function (xhr) {
                Roc.Logger.info('CartManager -> updateCartItem');
                Roc.Logger.info(xhr);
                var response = xhr.responseJSON || {};

                // TODO: make response include this data directly instead of reading from the dom?
                var itemData = $('[data-item-id="' + response.details.orderItemId + '"]').data('rocParams');
                
                trackCartAddOrRemove(itemData, response.details.addedQuantity)
                Roc.EventManager.notify(Roc.Events.cart.UPDATE_ITEM, response);
            }
        });
    }

    /**
     * Requests api to update shopping cart item delivery options
     * @param {} orderItemId 
     * @param {} quantity 
     * @param {} deliveryOptions
     * @param {} requestCustomFields - dictiornary of <string, object> for passing custom fields to API
     * @returns {} 
     */
    function updateCartItemDelivery(orderItemId, deliveryOptions, requestCustomFields) {
        var request = {
            orderId: '{orderId}',
            orderItemId: orderItemId,
            deliveryOptions: deliveryOptions,
            requestCustomFields: initCartSource(requestCustomFields, Roc.Enums.cartSource.UPDATE_DELIVERY_OPTION)
        };

        $.proxyRequest({
            type: 'POST',
            url: '/api/store/cart/delivery',
            data: JSON.stringify(request),
            dataType: 'json',
            complete: function (xhr) {
                Roc.Logger.info('CartManager -> updateCartItemDelivery');
                Roc.Logger.info(xhr);
                var response = xhr.responseJSON || {};
                Roc.EventManager.notify(Roc.Events.cart.UPDATE_ITEM, response);
            }
        });
    }

    /**
     * Requests api to remove item from the shopping cart
     * @param {} orderItemId - cart item id
     * @returns {} 
     */
    function removeOrderItem(orderItemId, productId) {
        $.proxyRequest({
            type: 'DELETE',
            url: '/api/store/cart/{orderId}/' + orderItemId,
            dataType: 'json',
            complete: function (xhr) {
                var response = xhr.responseJSON || {};

                Roc.Logger.info('CartManager -> removeOrderItem');
                Roc.Logger.info(xhr);
                response.success = xhr.status === 200;
                response.orderItemId = orderItemId;

                // TODO: make response include this data directly instead of reading from the dom?
                var itemData = $('[data-item-id="' + response.orderItemId + '"]').data('rocParams');

                Roc.EventManager.notify(Roc.Events.cart.REMOVE_ITEM, response);
                Roc.Logger.info(response);
                trackRemoveFromCart(itemData);
            }
        });
    }

    /**
     * Requests api to save cart item 'for later'
     * @param {} orderItemId  - ID of cart item
     * @param {} requestCustomFields - dictiornary of <string, object> for passing custom fields to API
     * @returns {} 
     */
    function saveOrderItem(orderItemId, requestCustomFields) {
        $.proxyRequest({
            type: 'POST',
            data: JSON.stringify({
                'OrderItemId': orderItemId,
                'OrderId': '{orderId}',
                requestCustomFields: initCartSource(requestCustomFields, Roc.Enums.cartSource.SAVE_ITEM)
            }),
            url: '/api/store/cart/saveitem',
            complete: function(xhr) {
                var response = xhr.responseJSON || {};

                Roc.Logger.info('CartManager -> saveOrderItem');
                Roc.Logger.info(xhr);
                response.success = xhr.status === 200;
                response.orderItemId = orderItemId;

                // TODO: make response include this data directly instead of reading from the dom?
                var itemData = $('[data-item-id="' + response.orderItemId + '"]').data('rocParams');

                trackRemoveFromCart(itemData);
                Roc.EventManager.notify(Roc.Events.cart.SAVE_ITEM, response);
                Roc.Logger.info(response);
            }
        });
    }

    /**
     * This function requests api to move back (re-add) saved cart item to the shopping cart.
     * @param {} productId - ID of saved product
     * @param {} requestCustomFields - dictiornary of <string, object> for passing custom fields to API
     * @returns {} 
     */
    function moveSavedItemToCart(e, savedItemId, requestCustomFields) {
        Roc.Core.lockButton(e.currentTarget);

        $.proxyRequest({
            type: 'POST',
            url: '/api/store/cart/movesaveditem/',
            data: JSON.stringify({
                'SavedItemId': savedItemId,
                'OrderId': '{orderId}',
                'RemoteIP': '{RemoteIP}',
                requestCustomFields: initCartSource(requestCustomFields, Roc.Enums.cartSource.MOVE_SAVED_ITEM_TO_CART)
            }),
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            serverCompleteAction: 'SetCurrentOrderId',
            complete: function(xhr) {
                var response = xhr.responseJSON || {};

                Roc.Logger.info('CartManager -> moveSavedItemToCart');
                Roc.Logger.info(xhr);
                response.savedItemId = savedItemId;
                Roc.EventManager.notify(Roc.Events.cart.MOVE_SAVED_ITEM, response);
                Roc.Core.releaseLockedButton(e.currentTarget);

                trackAddToCart(response)
            }
        });
    }

    /**
     * Requests api to remove item from 'saved for later'
     * @param {} savedItemId 
     * @returns {} 
     */
    function removeSavedItem(savedItemId) {
        return $.proxyRequest({
            type: 'DELETE',
            url: '/api/store/cart/saveditem',
            data: JSON.stringify({ 'SavedItemId': savedItemId }),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            complete: function (xhr) {
                Roc.Logger.info('CartManager -> removeSavedItem');
                Roc.Logger.info(xhr);
                Roc.EventManager.notify(Roc.Events.cart.REMOVE_SAVED_ITEM, {
                    'success': xhr.status === 200,
                    'savedItemId': savedItemId
                });
            }
        });
    }

    /**
     * Requests api to saved shopping cart.
     * @param {} cartName 
     * @param {} email 
     * @returns {} 
     */
    function saveOrder(cartName, email) {
        var requestData = {
            OrderId: '{orderId}',
            CartName: cartName
        };

        if (email) {
            requestData.Email = email;
        }

        $.proxyRequest({
            type: 'POST',
            url: '/api/store/cart/save',
            data: JSON.stringify(requestData),
            dataType: 'json',
            complete: function (xhr) {
                Roc.Logger.info('CartManager -> saveOrder');
                Roc.Logger.info(xhr);
                requestData.success = xhr.status === 200;
                Roc.EventManager.notify(Roc.Events.cart.CART_SAVED, requestData);
            }
        });
    }

    /**
     * Requests api to load saved shopping cart
     * @param {} cartId 
     * @param {} options - optional param which can be used to provide beforeSend callback
     * @param {} requestCustomFields - dictiornary of <string, object> for passing custom fields to API
     * @returns {} 
     */
    function loadSavedCart(cartId, options, requestCustomFields) {
        options = options || {};
        $.proxyRequest({
            type: 'POST',
            url: '/api/store/cart/loadordercart',
            data: JSON.stringify({
                cartId: cartId,
                currentOrderId: '{orderId}',
                requestCustomFields: initCartSource(requestCustomFields, Roc.Enums.cartSource.LOAD_CART)
            }),
            contentType: 'application/json; charset=utf-8',
            beforeSend: options.beforeSend || null,
            serverCompleteAction: 'UpdateCurrentOrderId',
            complete: function(xhr) {
                if (xhr.responseText && !xhr.responseJSON) {
                    xhr.responseJSON = JSON.parse(xhr.responseText);
                }
                Roc.Logger.info('CartManager -> loadSavedCart');
                Roc.Logger.info(xhr);
                Roc.EventManager.notify(Roc.Events.cart.CART_LOADED, xhr);
            }
        });
        return false;
    }

    /**
     * Requests api to remove requested shopping cart (saved previously).
     * @param {} cartId 
     * @param {} options - optional param which can be used to provide beforeSend callback
     * @returns {} 
     */
    function removeSavedCart(cartId, options) {
        options = options || {};
        return $.proxyRequest({
            type: 'DELETE',
            url: '/api/store/cart/saved?cartId=' + cartId,
            contentType: 'application/json; charset=utf-8',
            beforeSend: options.beforeSend || null,
            complete: function (xhr) {
                xhr.cartId = cartId;
                Roc.Logger.info('CartManager -> removeSavedCart');
                Roc.Logger.info(xhr);
                Roc.EventManager.notify(Roc.Events.cart.CART_REMOVED, xhr);
            }
        });
    }

    /**
     * Requests api to update shipping details
     * @param {} estimateShippingRequest 
     * @param {} requestType
     * @param {} requestCustomFields - dictiornary of <string, object> for passing custom fields to API
     * @returns {} 
     */
    function updateShippingDetails(shippingRequest, requestType, requestCustomFields) {
        shippingRequest.requestType = requestType;
        shippingRequest
            .requestCustomFields = initCartSource(requestCustomFields, Roc.Enums.cartSource.UPDATE_SHIPPING_DETAILS);

        $.proxyRequest({
            type: 'POST',
            url: '/api/store/cart/shippingdetails',
            data: JSON.stringify(shippingRequest),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            complete: function (xhr) {
                Roc.Logger.info('CartManager -> updateShippingDetails');
                Roc.Logger.info(xhr);
                Roc.EventManager.notify(Roc.Events.cart.UPDATE_SHIPPING_DETAILS, { xhr: xhr, request: shippingRequest });
            }
        });
    }

    /**
     * Requests api to re-order
     * @param {} cartId 
     * @param {} options 
     * @param {} requestCustomFields - dictiornary of <string, object> for passing custom fields to API
     * @returns {} 
     */
    function reOrder(cartId, options, requestCustomFields) {
        options = options || {};
        $.proxyRequest({
            type: 'POST',
            url: '/api/store/cart/reorder',
            data: JSON.stringify({
                orderId: cartId,
                currentOrderId: '{orderId}',
                requestCustomFields: initCartSource(requestCustomFields, Roc.Enums.cartSource.REORDER)
            }),
            contentType: 'application/json; charset=utf-8',
            beforeSend: options.beforeSend || null,
            serverCompleteAction: 'UpdateCurrentOrderId',
            complete: function(xhr) {
                if (xhr.responseText && !xhr.responseJSON) {
                    xhr.responseJSON = JSON.parse(xhr.responseText);
                }

                Roc.EventManager.notify(Roc.Events.cart.RE_ORDER, xhr);
                Roc.Logger.info('CartManager -> reOrder');
                Roc.Logger.info(xhr);
            }
        });
        return false;
    };

    /**
     * Requests api to get current shopping cart
     * @returns {} 
     */
    function getCurrentCart(forceRecalculate, requestCustomFields) {
        forceRecalculate = forceRecalculate || false;

        var request = {
            orderId: '{orderId}',
            forceRecalculate: forceRecalculate,
            requestCustomFields: initCartSource(requestCustomFields, Roc.Enums.cartSource.GET_CART)
        };

        $.proxyRequest({
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            url: '/api/store/cart/',
            data: JSON.stringify(request),
            complete: function (xhr) {
                Roc.Logger.info('CartManager -> getCurrentCart');
                Roc.Logger.info(xhr);
                var response = xhr.responseJSON || {};
                Roc.EventManager.notify(Roc.Events.cart.GET_CURRENT_CART, response);
            }
        });
    };

    /**
     * Requests api to apply promotion code for the cart
     * @param {} code to apply 
     * @returns {} 
     */
    function applyPromotionCode(code) {
        var request = {
            'promoCode': code,
            'orderId': '{orderId}'
        };
        $.proxyRequest({
            type: 'POST',
            dataType: 'json',
            data: JSON.stringify(request),
            contentType: 'application/json; charset=utf-8',
            url: '/api/store/cart/applycode/',
            complete: function (xhr) {
                Roc.Logger.info('CartManager -> applyPromotionCode');
                Roc.Logger.info(xhr);
                Roc.EventManager.notify(Roc.Events.cart.APPLY_PROMO_CODE, xhr);
            }
        });
    }

    /**
     * Requests api to remove promotion code from the cart
     * @param {} code to remove 
     * @returns {} 
     */
    function removePromotionCode(code) {
        var request = {
            'promoCode': code,
            'orderId': '{orderId}'
        };
        $.proxyRequest({
            type: 'POST',
            dataType: 'json',
            data: JSON.stringify(request),
            contentType: 'application/json; charset=utf-8',
            url: '/api/store/cart/removecode/',
            complete: function (xhr) {
                Roc.Logger.info('CartManager -> removePromotionCode');
                Roc.Logger.info(xhr);
                Roc.EventManager.notify(Roc.Events.cart.REMOVE_PROMO_CODE, xhr);
            }
        });
    }

    function initCartSource(requestCustomFields, value) {
        if (!requestCustomFields) {
            requestCustomFields = {};
        }
        if (!requestCustomFields.CartSource) {
            requestCustomFields.CartSource = value;
        }
        requestCustomFields.Path = window.location.pathname;
        requestCustomFields.RawUrl = window.location.pathname + window.location.search;
        return requestCustomFields;
    }

    /**
     * A module for making shopping cart api requests
     * @exports CartManager
     */
    var CartManager = {
        getSummary: getSummary,
        addCartItem: addCartItem,
        addCartItemBySku: addCartItemBySku,
        updateCartItem: updateCartItem,
        updateCartItemDelivery: updateCartItemDelivery,
        removeOrderItem: removeOrderItem,
        saveOrderItem: saveOrderItem,
        moveSavedItemToCart: moveSavedItemToCart,
        removeSavedItem: removeSavedItem,
        saveOrder: saveOrder,
        loadSavedCart: loadSavedCart,
        removeSavedCart: removeSavedCart,
        reOrder: reOrder,
        updateShippingDetails: updateShippingDetails,
        getCurrentCart: getCurrentCart,
        applyPromotionCode: applyPromotionCode,
        removePromotionCode: removePromotionCode
    };

    Roc.Logger.debug('CartManager.js Loaded:', CartManager);

    return CartManager;
});
